import React, { useEffect } from 'react'
import { Card, CardBody, CardTitle } from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { connect } from "react-redux";

// component
import ContactForm from "./_form";
import ContactFilters from "./_filters";
import TranslateButton from "../../../components/buttons/TranslateButton";
import GenericSwitch from "../../../components/genericComponents/genericSwitch";
import {ButtonTableDelete, ButtonTableEdit} from "../../../components/buttons/buttonsActions";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";

// labels
import {
    LB_ACTIONS, LB_ACTIVE, LB_CODE, LB_CONTACT_TYPE, LB_EMPTY_TABLE, LB_VALUE, LIST
} from "../../../components/i18n/i18n";

// actions
import {setFilter, setTableParams} from "../../../redux/actions/generalActions/listActions";
import {setLoading, setViewMode} from "../../../redux/actions/generalActions/mainActions";
import {setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {genericActions} from "../../../redux/actions/generics/GenericActions";

// services
import {contactService} from "../../../jwt/_services/hotel/contactService";

const ContactList = props => {
    const { pageSize, pageIndex, totalSize, listDomainObjects, filter } = props.listProps
    const { udn, app } = props.mainProps;

    useEffect(()=>{
        if( !app.id || !udn.id || filter)
            return

        props.setFilter( {
            onlyRegistered : true,
            fbDataBase: { id: app?.fbDataBase?.id },
            item :{
                udn : { id : udn.id }
            }
        } )
    },[ app, udn ])

    // realizar búsqueda cuando cambie el filtro
    useEffect(() => {
        if(!filter)
            return

        genericActions.search(contactService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter ]);

    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams( tableChangeParams.sizePerPage, currentIndex );
    };

    const confirmDelete = (data) => {
        return ConfirmDelete({ remove : genericActions.remove , data : data, fbDataBaseId :  app?.fbDataBase?.id, service: contactService } );
    };

    const editItem = (data) => {
        props.setForm(true, false, false);
        props.setItem(data);
        ModalFormContainer(ContactForm, { data: data, Form: ContactForm });
    }

    const handleStatusChange = (id, data, status) =>{
        const dataRequest = {
            fbDataBase:  { id : props.mainProps?.app?.fbDataBase?.id },
            item: { ...data, status:!status, id:id }
        }
        genericActions.update(id, dataRequest)
    }

    const actionsFormatter = (cell, row) => <>
        <ButtonTableEdit onClick={() => editItem(row)}/>
        <TranslateButton item={row} service={contactService} />
        <ButtonTableDelete onClick={() => confirmDelete(row)}/>
    </>

    const columns = [
        {
            dataField: 'id',
            headerStyle: {width: '0px'},
            text: 'ID',
            hidden: true
        }, {
            dataField: 'uid',
            headerStyle: {width: '200px'},
            text: 'UID'
        },  {
            dataField: 'code',
            text: `${LB_CODE}`,
            headerStyle: {width: '300px'},
        },{
            dataField: 'contactType',
            text: `${LB_CONTACT_TYPE}`,
            headerStyle: {width: '200px'},
        } ,{
            dataField: 'value',
            text: `${LB_VALUE}`
        },{
            dataField: 'status',
            text: `${LB_ACTIVE}`,
            headerStyle: {width: '80px'},
            headerAlign: 'center',
            align: 'center',
            formatter: (cell, row) => <GenericSwitch
                id={ row?.id }
                initialState={ row?.status }
                onChange={ () => handleStatusChange(row?.id, row, row?.status) }
            />
        }, {
            dataField: 'actions',
            isDummyField: true,
            text: `${LB_ACTIONS}`,
            headerStyle: {width: '200px'},
            headerAlign: 'center',
            align: 'center',
            formatter: actionsFormatter
        }
    ];

    return (<Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"> </i>{LIST}
        </CardTitle>

        <ContactFilters />

        <CardBody className="">
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={ listDomainObjects || [] }
                columns={ columns }
                noDataIndication={ LB_EMPTY_TABLE }
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={ handleTableChange }
            />
        </CardBody>
    </Card>)
}

const mapStateToProps = state => ({
    mainProps : state.mainProps,
    listProps : state.listProps,
})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setLoading,
    setViewMode,
    setForm,
    setItem
})
export default connect(mapStateToProps, mapActionsToProps)(ContactList)